import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 px-6">
      <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center">
        {/* Left Section */}
        <div className="text-center sm:text-left">
          <p className="text-sm">
            © {new Date().getFullYear()} SmartAuditx
          </p>
        </div>

        {/* Right Section */}
        <div className="flex space-x-4 mt-2 sm:mt-0">

          <a href="/terms" className="text-sm hover:underline">
            Terms of Use
          </a>
          <a href="/about" className="text-sm hover:underline">
            About
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
